import { CiSearch } from "react-icons/ci";
import { filterBySearch } from "../../../utils/filterUtils";
import { useProductsContext } from "../../../front/contexts";
import { useEffect, useState } from "react";
import CartItemCard from "../cart/CartItemCard";
import { useLocation, useNavigate } from "react-router-dom";
//import spinningLoaders from "../../../assets/loaderBlack.svg";
import services from '../../../services/index'
import commonObj from '../../../utils/Common';

let spinningLoaders = ''
const Search = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { allProducts, applyFilters } = useProductsContext();
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showList, setShowList] = useState(true);
  const [searching, setSearching] = useState(false);
  const [imgurl, setimgurl] = useState();


  useEffect(() => {
    if (location?.pathname !== "/products") {
      setSearch("");
    }
  }, [location]);
  useEffect(() => {
    setSearching(true);
    let id;
    id = setTimeout(() => {
      //setFilteredData(filterBySearch(search, allProducts));
      setSearching(false);
      if (location?.pathname === "/products" && !search) {
        applyFilters("searchText", search);
      }
    }, 500);

    return () => {
      clearTimeout(id);
    };
  }, [search]);

  const changeHandler = (e) => {
    setSearch(e.target.value);
    getProductList(e.target.value)
    if (!showList) setShowList(true);
  };
  const submitHandler = (e) => {
    e.preventDefault();
    applyFilters("searchText", search);
    setShowList(false);
    navigate("/products");
  };

  const getProductList =  async (srch) => {
    if(srch.length>2){
      const productsRes = await services.productService.getProductList( {filter: {s:srch} } )
      console.log(productsRes)
      if (productsRes.status === 1) {
        setimgurl(productsRes.data?.url)
        setFilteredData(filterBySearch(search, productsRes.data?.list?.rows));
      }
    }
  }

  return (
    <>
      <form
        onSubmit={submitHandler}
        className={`flex items-center py-2 px-3 header-search ${
          search && showList ? "rounded-t-md" : "rounded-full"
        } text-sm transition`}
      >
        <input
          className="w-full  bg-transparent focus:outline-none"
          type="search"
          value={search}
          placeholder={commonObj.getLabel('Search_Your_Product')}
          onChange={changeHandler}
        />
        <CiSearch />
      </form>
      {search && showList && (
        <ul className="absolute bg-amber-50 w-full max-h-72 overflow-auto rounded-b-md z-10">
          {searching ? (
            <li className="h-10 flex items-center justify-center">
              <img src={spinningLoaders} alt="Searching..." />
            </li>
          ) : filteredData.length ? (
            filteredData.map((product) => (
              <li key={product.id} className="">
                <CartItemCard
                  product={product}
                  isSearch={true}
                  setSearch={setSearch}
                  imgurl={imgurl}
                />
              </li>
            ))
          ) : (
            <li className="h-10 flex items-center justify-center">
              {commonObj.getLabel('No_Item_to_show')}
            </li>
          )}
        </ul>
      )}
    </>
  );
};

export default Search;
